import {
  CustomerDeactivationModalKey,
  CustomerDetailsKey,
  CustomerListPageKey,
  CustomerListTableKey,
  CustomerPendingListTableKey,
  CustomerUploadModalKey
} from '../../TModules';

export const translations = {
  [CustomerListTableKey]: {
    Identifier: 'Identifiant',
    Name: 'Nom',
    Status: 'Statut',
    DateJoined: "Date d'adhésion",
    Actions: 'Actions',
    SearchCustomers: 'Rechercher des clients',
    Activate: 'Activer',
    Deactivate: 'Désactiver',
    Active: 'Actif',
    Inactive: 'Inactif',
    Initial: 'Initial'
  },
  [CustomerUploadModalKey]: {
    HandleUpload: {
      SuccessMessage: 'Fichier téléchargé',
      ErrorMessage: 'Erreur lors du téléchargement du fichier.',
      Title: 'Télécharger le fichier client',
      OkText: 'Télécharger',
      CancelText: 'Annuler',
      UploadButton: 'Télécharger',
      UploadDraggerMessage:
        'Cliquez ou faites glisser le fichier dans cette zone pour le télécharger',
      DownloadSample: "Télécharger l'exemple",
      AcceptedFormat: 'Format accepté : fichiers .txt., .xlsx ou .csv uniquement'
    }
  },
  [CustomerPendingListTableKey]: {
    RequestId: 'ID de la demande',
    Customer: 'Client',
    RequestType: 'Type de demande',
    Status: 'Statut',
    Comment: 'Commentaire',
    LastUpdated: 'Dernière mise à jour',
    DateOfExpiry: "Date d'expiration",
    Actions: 'Actions',
    Comments: 'Commentaires',
    ViewDetails: 'Voir les détails',
    Approve: 'Approuver',
    ApproveRequests: 'Approuver les demandes',
    CustomerStampView: 'Vue du tampon client',
    LoyaltyProgramDetails: 'Programme de bonus détails',
    CustomerGameView: 'Vue du jeu client',
    CustomerRewardView: 'Vue de la récompense client',
    ApproveSelectedButton: 'Approuver la sélection',
    ReactivateCustomer: 'Réactiver Le Client',
    DeactivateCustomer: 'Désactiver Le Client',
    VoidVoucher: 'Annuler Le Bon',
    ModifyVoucher: 'Modifier Le Bon',
    CashbackIssue: 'Problème De Cashback',
    Issue: 'Émission de',
    Rewards: 'Récompenses',
    Reward: 'Récompense',
    Stamps: 'Timbres',
    Gametries: 'Essais De Jeu',
    GameTries: 'Essais De Jeu',
    GAMETRIES: 'ESSAIS DE JEU',
    Voucher: 'Bon',
    LoyaltyPoints: 'Points De Fidélité',
    Cashbackissue: 'Émission De Cashback',
    Loyaltydelete: 'Suppression De Fidélité',
    AddProgressPoints: 'Ajouter des points de progression',
    MarkQuestTaskComplete: 'Marquer la tâche de quête comme terminée',
    IssueInstantReward: 'Émettre une récompense instantanée',
    IssueRaffleTicket: 'Émettre un billet de tombola',
    CustomerProgressPointsPendingView: 'Points de progression en attente',
    CustomerQuestTaskPendingView: 'Tâche de quête en attente',
    CustomerInstantRewardPendingView: 'Récompense instantanée en attente',
    CustomerRaffleTicketPendingView: 'Billet de tombola en attente',
    ApproveMultipleMessageModal: {
      SuccessMessage: 'Téléchargements approuvés',
      FailureMessage: "Erreur lors de l'approbation du fichier.",
      Title: 'Approuver plusieurs demandes ?',
      OkText: 'Approuver sélectionné',
      DescriptionText: `
      Êtes-vous sûr de vouloir approuver toutes les demandes sélectionnées ?
      <br />
      Veuillez vérifier les détails avant d'approuver car cette action ne peut pas être annulée.`
    },
    ApproveRequestModal: {
      SuccessMessage: 'Demande approuvée',
      FailureMessage: "Erreur lors de l'approbation de la demande.",
      Title: 'Approuver la demande ?',
      OkText: 'Approuver',
      DescriptionText: `Êtes-vous sûr de vouloir approuver cette demande ?`
    },
    UploadCommentModal: {
      ViewAndAddComments: 'Voir et ajouter des commentaires',
      Content: 'Contenu',
      DeleteButton: 'Bouton supprimer',
      Time: 'Heure',
      ErrorAddingComment: "Erreur lors de l'ajout du commentaire",
      CommentAdded: 'Commentaire ajouté',
      EnterYourCommentHere: 'Entrez votre commentaire ici',
      AddComment: 'Ajouter un commentaire',
      CommentsAdded: 'Commentaires ajoutés',
      Delete: 'Supprimer'
    },
    DeleteCommentModal: {
      CommentDeleted: 'Commentaire supprimé',
      ErrorDeletingComment: 'Erreur lors de la suppression du commentaire',
      DeleteComment: 'Supprimer le commentaire ?',
      Delete: 'Supprimer',
      DescriptionFirstLine: `Êtes-vous sûr de vouloir supprimer votre commentaire ?`,
      DescriptionSecondLine: `Cette action ne peut pas être annulée.`
    }
  },
  [CustomerListPageKey]: {
    PendingRequests: 'Demandes en attente',
    Customers: 'Clients',
    CustomersList: 'Liste des clients',
    Upload: 'Télécharger',
    TransactionRequests: 'Demandes de transaction',
    DeactivatingCustomer: 'Désactivation Du Client...',
    DeactivationRequestSubmitted: 'Demande De Désactivation Du Client Soumise Pour Approbation !',
    SuccessfullyDeactivated: 'Désactivation Réussie !',
    DeactivationFailed: 'Échec De La Désactivation',
    SuccessfullyDeleted: 'Suppression Réussie !',
    DeletingCustomer: 'Suppression Du Client...',
    ActivatingCustomer: 'Activation Du Client...',
    ActivationRequestSubmitted: 'Demande D’Activation Du Client Soumise Pour Approbation !',
    SuccessfullyActivated: 'Activation Réussie !',
    ActivationFailed: 'Échec De L’Activation',
    LoadingCustomer: 'Chargement Du Client...',
    ErrorRetrievingCustomer: 'Une Erreur S’Est Produite !'
  },
  [CustomerDeactivationModalKey]: {
    ProvideReasonForDeactivation: 'Fournir une raison pour la désactivation',
    ProvideReasonForActivation: "Fournir une raison pour l'activation",
    Deactivate: 'Désactiver',
    Activate: 'Activer',
    Cancel: 'Annuler',
    DeactivationReason: 'Veuillez sélectionner la raison'
  },
  [CustomerDetailsKey]: {
    ID: 'ID',
    CustomerDetails: 'Détails du client',
    RewardsLabel: 'Rémunération',
    Identifier: 'Identifiant',
    UserInfo: 'Infos utilisateur',
    FirstName: 'Prénom',
    MiddleName: 'Deuxième prénom',
    LastName: 'Nom de famille',
    Gender: 'Genre',
    Address: 'Adresse',
    Birthday: 'Anniversaire',
    JoinedAt: 'Rejoint le',
    CreatedVia: 'Créé via',
    ReferralCode: 'Code de parrainage',
    Email: 'Email',
    Phone: 'Téléphone',
    State: 'État',
    City: 'Ville',
    Race: 'Race',
    Segment: 'Segment',
    AccountId: 'ID de compte',
    Nationality: 'Nationalité',
    AlternateId: 'ID alternatif',
    ProductType: 'Type de produit',
    Classification: 'Classification',
    LocationState: 'État de localisation',
    PreferredLanguage: 'Langue préférée',
    FindRewardByNameTypeOrMerchant: 'Trouver une rémunération par nom, type ou commerçant',
    IssueRewards: 'Établir les rémunération',
    ErrorRetrievingCustomer: 'Erreur lors de la récupération du client',
    CustomerRewards: 'Récompenses du client',
    LoyaltyProgram: 'Programme de bonus',
    AccountDetails: 'Détails du compte',
    Campaigns: 'Campagnes',
    EventLogs: {
      TabLabel: "Journaux d'événements",
      Filters: {
        EventName: "Nom de l'événement",
        EventNamePlaceholder: "Sélectionner le nom de l'événement",
        Helper: "Filtrer la liste par nom d'événement"
      },
      Table: {
        ID: 'ID',
        EventName: "Nom de l'événement",
        Params: 'Paramètres',
        State: 'État',
        CreatedAt: 'Créé le'
      },
      Detail: {
        Title: "Détail du journal d'événements",
        Back: "Retour aux journaux d'événements",
        RuleOutcomes: 'Résultats des règles',
        Error: "Impossible de charger les détails du journal d'événements.",
        NoData: "Journal d'événements introuvable.",
        Fields: {
          ID: 'ID',
          EventName: "Nom de l'événement",
          State: 'État',
          EventParams: "Paramètres de l'événement",
          CreatedAt: 'Créé le',
          UpdatedAt: 'Mis à jour le',
          ProcessingStartedAt: 'Traitement démarré le',
          ProcessingCompletedAt: 'Traitement terminé le'
        }
      }
    },
    Transactions: {
      TabLabel: 'Transactions',
      Filters: {
        State: 'État',
        StatePlaceholder: 'Sélectionner un état',
        TransactionReference: 'Référence de transaction',
        TransactionReferencePlaceholder: 'Saisir la référence de transaction',
        CreatedAtRange: 'Plage de dates de création',
        CreatedAtRangeStartPlaceholder: 'Date de début',
        CreatedAtRangeEndPlaceholder: 'Date de fin',
        Helper: 'Filtrer la liste par état, référence ou date de création'
      },
      Table: {
        ID: 'ID',
        Reference: 'Référence',
        Amount: 'Montant',
        Properties: 'Propriétés',
        State: 'État',
        CreatedAt: 'Créé le'
      },
      Detail: {
        Title: 'Détail de la transaction',
        Back: 'Retour aux transactions',
        Error: 'Impossible de charger les détails de la transaction.',
        NoData: 'Transaction introuvable.',
        RuleOutcomes: 'Résultats des règles',
        Fields: {
          ID: 'ID',
          Reference: 'Référence',
          Amount: 'Montant',
          State: 'État',
          CreatedAt: 'Créé le',
          UpdatedAt: 'Mis à jour le',
          TransactionDate: 'Date de transaction',
          TransactionType: 'Type de transaction',
          Currency: 'Devise',
          ProcessedAt: 'Traitement effectué le',
          ProcessAt: 'Traitement prévu le',
          TransactionStatus: 'Statut de la transaction',
          UniqueTransactionId: 'ID de transaction unique',
          UserAccountId: 'ID de compte utilisateur',
          AmountPoint: 'Montant de points',
          MerchantUserAccountId: 'ID de compte utilisateur marchand',
          WorkflowId: 'ID de workflow',
          Properties: 'Propriétés'
        }
      }
    },
    RuleOutcomesTable: {
      RuleOutcomeId: 'ID de résultat de règle',
      TransactionRuleId: 'ID de règle de transaction',
      TransactionRuleName: 'Nom de la règle de transaction',
      State: 'État',
      AdditionalInfo: 'Informations supplémentaires',
      Empty: 'Aucun résultat de règle disponible.'
    },
    FilteringChecks: {
      TabLabel: 'Vérifications de filtrage',
      RewardTabLabel: 'Filtrage des récompenses',
      CampaignTabLabel: 'Filtrage des campagnes',
      HelperText:
        'Exécutez un contrôle pour voir quels filtres passent ou échouent pour ce client.',
      PassedFilters: 'Filtres validés',
      FailedFilters: 'Filtres échoués',
      NoPassedFilters: 'Aucun filtre validé',
      NoFailedFilters: 'Aucun filtre échoué',
      GenericError: 'L’ID client est invalide.',
      NotFoundError: '404 introuvable',
      ToggleHide: 'Masquer la section',
      ToggleShow: 'Afficher la section',
      Reward: {
        Title: 'Vérification du filtrage des récompenses',
        Description:
          'Saisissez un ID client pour voir quels filtres incluent ou excluent ce client pour la récompense.',
        Placeholder: 'Saisissez l’ID client',
        InputLabel: 'ID client',
        Button: 'Vérifier les filtres client',
        MissingIdError: 'Veuillez saisir un ID client'
      },
      Campaign: {
        Title: 'Vérification du filtrage des campagnes',
        Description:
          'Saisissez un ID client pour voir quels filtres incluent ou excluent ce client pour la campagne.',
        Placeholder: 'Saisissez l’ID client',
        InputLabel: 'ID client',
        Button: 'Vérifier les filtres client',
        MissingIdError: 'Veuillez saisir un ID client'
      }
    },
    CustomerIDNotFound: 'ID client non trouvé',
    DeleteUser: "Supprimer l'utilisateur",
    Activate: 'Activer',
    Deactivate: 'Désactiver',
    ACTIVE: 'ACTIF',
    Inactive: 'Inactif',
    DeactivationReason: 'Raison de la désactivation',

    RewardIssueMakerCheckerErrorMessage: 'Vous ne pouvez pas approuver votre propre demande',
    RewardIssueErrorMessage: "L'erreur s'est produite lors de l'émission de récompenses",
    RewardIssueErrorsOccurredWhileIssuingRewards:
      'Les erreurs se sont produites lors de la délivrance des récompenses',
    RewardIssueSuccessMessage: 'Récompense émise avec succès',
    RewardIssueMakerCheckerSuccessMessage:
      "Demande d'émission de récompense soumise pour approbation",
    RewardIssueUnexpectedResponseFormat: 'Format de réponse inattendu',
    Stamps: 'carte de fidélité',
    Games: 'Jeux',
    ProgressCampaign: 'Campagne de progrès',
    AddressState: "État de l'adresse",
    AddressCity: "S'adresser à la ville",
    Company: 'Entreprise',
    EmailTags: 'Tags e-mail',
    BusinessType: "Type d'entreprise",
    INACTIVE: 'INACTIF',
    Cashback: 'Cashback',

    Name: 'Nom',
    Status: 'Statut',
    Tenure: 'Durée',
    Tier: 'Niveau',
    Balance: 'Solde',
    ToNextTier: 'Au prochain niveau',
    MembershipExpiry: "Expiration de l'adhésion",

    CashbackModal: {
      CancelIssuanceModal: {
        Title: 'Annuler la demande d’émission de cashback ?',
        MessageLineOne:
          'La demande d’émission est en attente d’approbation. Êtes-vous sûr de vouloir l’annuler ?'
      },
      ApproveIssuanceModal: {
        Title: 'Approuver l’émission de cashback',
        MessageLineOne:
          'Êtes-vous sûr de vouloir approuver cette émission de cashback ? Cette action est irréversible.'
      }
    },

    Rewards: {
      FindRewardByNameTypeOrMerchant: 'Trouver une rémunération par nom, type ou commerçant',
      IssueRewardsManually: 'Établir manuellement les rémunérations',
      Issued: 'Émis',
      Pending: 'En attente',
      GiftedAway: 'Offert',
      Redeemed: 'Utilisé',
      RedemptionInProgress: 'Rachat en cours',
      FullyRedeemed: 'Complètement utilisé',
      Voided: 'Annulé',
      Expired: 'Expiré',
      Archived: 'Archivé',

      RequestType: 'Type de demande',
      CancelVoidRequest: "Annuler la demande d'annulation",
      CancelUpdateRequest: 'Annuler la demande de mise à jour',
      CancelIssueRequest: 'Annuler la demande de problème',
      ErrorApprovingRewards: "Erreur lors de l'approbation des récompenses",

      Name: 'Nom',
      DeletionRequested: 'Suppression demandée',
      ID: 'ID',
      Merchant: 'Commerçant',
      DateOfIssued: "Date d'émission",
      ValidFrom: 'Valide à partir de',
      ValidTo: "Valide jusqu'à",
      VoucherCode: 'Code du bon',
      AdminFee: 'Frais administratifs',
      Action: 'Action',
      DateOfExpired: "Date d'expiration",
      DateOfGifted: 'Date de cadeau',
      DateOfRedeemed: 'Date de rachat',
      RequestId: 'ID de la demande',
      Status: 'Statut',
      RewardId: 'ID de la récompense',
      IssuedOn: 'Émis le',

      VoidVoucher: 'Annuler le bon',
      ChangeExpiryDate: "Modifier la date d'expiration",
      AmendReward: 'Modifier la récompense',
      UndoRedeem: 'Annuler le rachat',
      ThereIsNoActionForGiftedVoucher: 'Aucune action pour le bon offert.',
      RevertBackToIssued: 'Revenir à émis',
      WaiveAdminFee: 'Renoncer aux frais administratifs',
      DeleteReward: 'Supprimer la récompense',
      ViewComments: 'Voir les commentaires',
      ApproveIssue: "Approuver l'émission",

      ViewAndAddComments: 'Voir et ajouter des commentaires',
      RequestHasBeenApproved: 'La demande a été approuvée',
      SomethingWentWrong: "Quelque chose s'est mal passé",
      HandleUndoRedeemErrorMessage:
        "Impossible d'annuler le rachat - veuillez modifier la date d'expiration et réessayer.",
      HandleUndoRedeemConfirmModalTitle: 'Confirmer',
      HandleUndoRedeemConfirmModalMessage: "Cela rétablira l'état du bon à Émis - continuer ?",

      HandleVoidVoucherMakerCheckerSuccessMessage: "Demande d'annulation soumise pour approbation",
      HandleVoidVoucherSuccessMessage: 'Le bon est annulé',
      HandleVoidVoucherConfirmModalMakerCheckerRightButtonText: "Demander l'annulation",
      HandleVoidVoucherConfirmModalRightButtonText: 'Confirmer',
      HandleVoidVoucherConfirmModalMakerCheckerTitle: "Soumettre la demande d'annulation ?",
      HandleVoidVoucherConfirmModalTitle: 'Confirmer',
      HandleVoidVoucherConfirmModalMakerCheckerMessage:
        "Êtes-vous sûr de vouloir demander l'annulation du bon de récompense ? Une fois approuvé, vous ne pourrez pas le restaurer.",
      HandleVoidVoucherConfirmModalMessage: 'Cela annulera le bon de récompense - continuer ?',

      HandleRevertRedemptionToIssuedConfirmModalTitle: 'Confirmer',
      HandleRevertRedemptionToIssuedMessageConfirmModalMessage:
        "Cela rétablira l'état du bon à Émis - continuer ?",

      ShowOCBCDemoConfirmModalTitle: 'Confirmer',
      ShowOCBCDemoConfirmModalMessage: 'Cela renoncera aux frais administratifs - continuer ?'
    },

    IssueRewardsModal: {
      Title: 'Établir manuellement les rémunérations',
      OkText_one: 'Établir {{count}} rémunération',
      OkText_other: 'Établir {{count}} rémunérations',
      SearchPlaceholder: 'Trouver une rémunération par nom, type ou commerçant',
      ActiveTabLabel: 'Actif',
      PrivateTabLabel: 'Privé',
      CancelText: 'Annuler',

      CustomerRewardsConfirmationModal: {
        RewardName: 'Nom de la rémunération',
        RewardPrices: 'Récompenser les prix',
        FreeOrPaid: 'Gratuit/Payant',
        ConfirmSellPrice: 'Confirmer le prix de vente',
        And: 'et',
        Points: 'points',
        Or: 'OU',
        Paid: 'Payé',
        Free: 'Gratuit',
        Cancel: 'Annuler',
        IssueRewards: 'DÉPENSER LA RÉMUNÉRATION'
      }
    },
    IssueRewardsTable: {
      Name: 'Nom',
      Merchant: 'Commerçant',
      ValidityPeriod: 'Période de validité',
      Balance: 'Solde'
    },
    AuditLog: {
      Title: "Journal d'audit",
      LastUpdatedAt: 'Dernière mise à jour à',
      IpAddress: 'Adresse IP',
      User: 'Utilisateur',
      Action: 'Action',
      Description: 'Description',
      RenderSummaryIsCreated: 'créé',
      RenderSummaryIsUpdated: 'mis à jour',

      Details: 'Détails',
      Old: 'Ancien',
      New: 'Nouveau',
      Audience: {
        Created: 'Audience created',
        NameUpdated: 'Audience name updated',
        FiltersUpdated: 'Filter customers updated',
        FileUploaded: 'Audience File uploaded',
        FileRemoved: 'Audience File removed',
        FileRelationChanged: 'Audience File relation changed',
        Uploaded: 'uploaded',
        Removed: 'removed',
        RelationChangedTo: 'relation changed to',
        NameLabel: 'Audience name',
        Criteria: {
          Age: 'Age',
          Gender: 'Gender',
          CustomAttributes: 'Custom Attributes'
        },
        AttributeGroup: 'Customer attributes',
        AttributeGroupRaw: 'Customer attributes (excluded group)'
      },
      DetailsColumn: {
        AutoFillStamps: 'Remplissage automatique des tampons',
        Wedges: 'Segments',
        LandingPage: "Page d'accueil",
        EnrolmentType: "Type d'inscription",
        AutoEnrolUsers: 'Inscription automatique des utilisateurs',
        State: 'État',
        NameEn: 'Nom en',
        Ordering: 'Classement',
        Timezone: 'Fuseau horaire',
        StartDate: 'Date de début',
        AutoIssueMoves: 'Mouvements automatiques',
        TypeOfCampaign: 'Type de campagne',
        OutcomesPerMove: 'Résultats par mouvement',
        TypeOfCampaignReferral: 'Type de parrainage de campagne',
        Rewards: 'Récompenses',
        PeriodUnits: 'Unités de période',
        RewardsOrdering: 'Classement des récompenses',
        NoOfStampsPerRow: 'Nombre de tampons par ligne',
        TotalStampsOnCard: 'Total des tampons sur la carte',
        DisplayPropertiesEn: "Propriétés d'affichage En",
        DisplayPropertiesTh: "Propriétés d'affichage Th",
        DisplayPropertiesVi: "Propriétés d'affichage Vi",
        DisplayPropertiesZh: "Propriétés d'affichage Zh",
        NoOfStampsPerColumn: 'Nombre de tampons par colonne',
        CampaignIntervalPeriod: "Période d'intervalle de campagne",
        DisplayPropertiesZhHans: "Propriétés d'affichage Zh Hans",
        DisplayPropertiesZhHant: "Propriétés d'affichage Zh Hant",

        Header: 'En-tête',
        CardImage: 'Image de la carte',
        ButtonText: 'Texte du bouton',
        ThumbnailImage: 'Image miniature',
        ButtonBgColour: 'Couleur de fond du bouton',
        GiftActiveImage: 'Image cadeau active',
        ButtonTextColour: 'Couleur du texte du bouton',
        StampActiveImage: 'Image tampon active',
        DisplayCampaignAs: 'Afficher la campagne comme',
        GiftInactiveImage: 'Image cadeau inactive',
        ButtonExternalLink: 'Lien externe du bouton',
        StampInactiveImage: 'Image tampon inactive',
        CardBackgroundImage: 'Image de fond de la carte',
        Cols: 'Colonnes',
        Rows: 'Lignes',
        Tags: 'Tags',
        Labels: 'Étiquettes',
        Referee: 'Filleul',
        Categories: 'Catégories',
        DescriptionEn: 'Description En',
        TermsAndConditionsEn: 'Conditions générales En',
        RefereeTotalRewardLimit: 'Limite totale de récompense du filleul',
        ClaimPrize: 'Réclamer le prix',
        StampsAwarded: 'Tampons attribués',
        Status: 'Statut',
        Value: 'Valeur',
        Operators: 'Opérateurs',
        RuleName: 'Nom de la règle',
        Body: 'Corps',
        MilestonesSuccessImage: 'Image de succès des étapes',
        SelectRuleAttribute: "Sélectionner l'attribut de règle",
        EndDate: 'Date de fin',
        GrandPrizeOutcome: 'Résultat du grand prix',
        RaffleTicketOutcome: 'Résultat du ticket de tirage'
      }
    },
    DeleteCustomerModal: {
      Title: "Supprimer l'utilisateur ?",
      OkText: 'confirmer',
      CancelText: 'Retourner',
      DescriptionLineOne: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
      DescriptionLineTwo: 'Cette action ne peut pas être annulée.',
      Name: 'Nom :',
      Identifier: 'Identifiant :',
      MakesCheckerErrorMessage:
        "Implémentez l'intégration de l'API avec Maker Checker en cours de progrès"
    },

    LoyaltyProgramsTable: {
      Name: 'Nom',
      Status: 'Statut',
      Tenure: 'Durée',
      Tier: 'Niveau',
      Balance: 'Solde',
      ToNextTier: 'Au prochain niveau',
      MembershipExpiry: "Expiration de l'adhésion",
      Actions: 'Actions'
    },
    LoyaltyProgramDetailsModal: {
      Title: 'Programme de bonus détails',
      CloseButton: 'FERMER',
      Active: 'Actif',
      Pending: 'En attente',
      Actions: 'Actions',
      ActionCancelRequest: 'Annuler la demande',
      ActionApproveIssue: "Approuver l'émission",
      ActionApproveDeletion: 'Approuver la suppression',
      ActionDenyDeletion: 'Refuser la suppression',
      ActionComments: 'Commentaires',
      ActionCommentsModalTitle: 'Voir et ajouter des commentaires',

      CancelIssuance: "Annuler l'émission",
      CancelDeletion: 'Annuler la suppression',

      Event: 'Événement',
      EventButton: 'Suppression demandée',
      Carryforward: 'Report',
      Status: 'Statut',
      SubmissionDate: 'Date de soumission',
      Points: 'Points',
      ExpiresAt: 'Expire le',
      TransactionId: 'ID de transaction',
      LoyaltyTransactionId: 'ID de transaction de fidélité',
      AmountTransacted: 'Montant transigé',
      TransactionAmount: 'Montant de la transaction',
      TransactionDate: 'Date de transaction',
      Date: 'Date',
      TransactionRef: 'Réf. de transaction',
      AwardingTransactionId: "ID de transaction d'attribution",
      Properties: 'Propriétés',
      Merchant: 'Commerçant',
      GlAccountNumber: 'Numéro de compte GL',
      CostCenterId: 'ID centre de coût',
      BranchCode: 'Code de la succursale',

      ChangeStatus: 'Changer le statut',
      ChangeTier: 'Changer le niveau',
      AddOrRemovePoints: 'Ajouter / Supprimer des points',
      AmountIsRequired: 'Le Montant Est Obligatoire',
      AmountMustBeNonZero: 'Le Montant Doit Être Non Nul',

      PointsAwarded: 'Points Attribués',

      ChangeStatusForm: {
        Active: 'Actif',
        Inactive: 'Inactif',
        Save: 'Sauvegarder'
      },
      ChangeTierForm: {
        Label: 'Remplacer le niveau expire le:',
        Save: 'Sauvegarder'
      },
      PointsForm: {
        SelectGlAccount: 'Sélectionner le compte GL',
        GlAccountType: 'Type de compte GL',
        GlAccountName: 'Nom du compte GL',
        Message: 'Écrivez un message pour accompagner cet ajustement de points.',
        AdjustPointsButton: 'Ajuster les points',
        GLAccountIdIsRequired: 'Identifiant Du Compte GL Est Obligatoire',
        GLAccountTypeIsRequired: 'Type De Compte GL Est Obligatoire',
        GLAccountNameIsRequired: 'Nom Du Compte GL Est Obligatoire'
      },
      UpdateLoyaltyProgramCustomerStateSuccessMessage: 'État mis à jour',
      UpdateLoyaltyProgramCustomerStateErrorMessage: 'quelque chose a mal tourné',
      UpdateLoyaltyProgramCustomerTierSuccessMessage: 'Niveau mis à jour',
      UpdateLoyaltyProgramCustomerTierErrorMessage: 'quelque chose a mal tourné',
      CreateCustomerLoyaltyTransaction: {
        GLAccountTypeRequiredMessage: 'Le type de compte GL est requis',
        GlAccountNameRequiredMessage: 'Le nom du compte GL est requis',
        MakerCheckerSuccessMessage: "Demande d'émission de points soumise pour approbation",
        SuccessMessage: 'Transaction ajoutée',
        ErrorMessage: 'quelque chose a mal tourné'
      },
      DeleteCustomerRequestLoyaltyTransaction: {
        SuccessMessage: 'Demande annulée',
        ErrorMessage: 'quelque chose a mal tourné'
      },
      ApproveDenyCustomerRequestLoyaltyTransaction: {
        ApproveSuccessMessage: 'La demande a été ',
        ErrorMessage: 'quelque chose a mal tourné',
        RequestHasBeenDeletedMessage: 'La demande a été supprimée',
        RequestHasBeenApprovedMessage: 'La demande a été approuvée'
      },
      DeleteCustomerLoyaltyTransaction: {
        MakerCheckerSuccessMessage:
          'Demande de suppression de transaction soumise pour approbation',
        SuccessMessage: 'Transaction supprimée',
        ErrorMessage: 'quelque chose a mal tourné'
      },
      RecoverCustomerLoyaltyTransaction: {
        SuccessMessage: 'Transaction récupérée',
        ErrorMessage: 'quelque chose a mal tourné'
      },
      DeleteCustomerLoyaltyTransactionModal: {
        ActiveTitle: 'Soumettre la demande de suppression ?',
        ActiveOkText: 'Demander la suppression',
        ActiveCancelText: 'Annuler',
        CancelText: 'Retour',
        ActiveMessage:
          'Êtes-vous sûr de vouloir demander la suppression de ces points ? Une fois approuvé, vous ne pourrez pas les restaurer.',
        MessageLineOne: `L'émission de ces points est en attente d'approbation. Êtes-vous sûr de vouloir annuler la demande ?`,
        MessageLineTwo: 'Cette action ne peut pas être annulée.',

        CancelDeletionTitle: 'Annuler la demande de suppression des points?',
        Title: "Annuler la demande d'émission de points ?",
        OkText: 'Confirmer',
        MessageLineOneDeletion: "La suppression de ces points est en attente d'approbation. "
      },
      ApproveDenyModal: {
        DenyDeletionOkText: 'Refuser',
        OkText: 'Approuver',
        ApproveIssueTitle: 'Approuver le problème des points de fidélité',
        ApproveDeletionTitle: 'Approuver la suppression des points de fidélité',
        DenyDeletionTitle: 'Refuser la demande de suppression de points de fidélité',
        ApproveIssueAndDeletionMessageLineOne: 'Êtes-vous sûr de vouloir approuver cela',
        ApproveIssueAndDeletionMessageLineTwo: 'de points de fidélité ? ',
        Message: 'Êtes-vous sûr de vouloir nier la suppression de ces points de fidélité? ',
        Issuance: 'émission',
        Deletion: 'effacement'
      },

      LineProgressBar: {
        HeaderDateText: 'début de période',
        CustomerTierText: "L'utilisateur est actuellement dans",
        Tier: 'Niveau',
        CustomerForcedMinimumTierText: "L'utilisateur a été forcé dans le niveau minimum",
        CustomerForcedMaximumTierText: `L'utilisateur a été `,
        FORCED: 'FORCÉ',
        into: 'dans',
        EndOfPeriod: 'fin de période',
        ForcedTier: 'Niveau forcé',
        ForcedMinTier: 'Niveau minimum forcé',
        UserHasBeen: "L'utilisateur a été",
        Forced: 'forcé',
        To: 'à',
        Status: 'statut',
        Until: "jusqu'à",
        DeleteForcedTierLinkText: 'X Désactiver le niveau forcé',
        ToMinimum: 'au minimum',
        TheUserHasEarned: "L'utilisateur a gagné",
        Points: 'Point(s)',
        DuringThisCycle: 'pendant ce cycle.',
        TheUserRequires: "L'utilisateur nécessite",
        ToLevelUpTo: 'pour passer au niveau supérieur',
        TheUserHas: "L'utilisateur a",
        Available: 'disponible.'
      }
    },

    CashbackTable: {
      CashbackTransactionID: 'Cashback Transaction ID',
      Event: 'Événement',
      CashbackAmount: 'Montant du Cashback',
      Currency: 'Devise',
      Date: 'Date',
      CashbackRuleID: 'ID de la règle de Cashback',
      TransactionID: 'ID de la transaction',
      TransactionAmount: 'Montant de la transaction',
      LoyaltyProgramID: 'ID du programme de fidélité',
      Points: 'Points',
      IssueCashback: 'Émettre un Cashback',
      AvailablePoints: 'Points disponibles',
      NoOfPointsToRedeem: 'Nombre de points à échanger',
      Back: 'Retour',
      InsufficientPoints: 'Points insuffisants',
      CashbackMaxError: 'Le montant du cashback ne peut pas dépasser',
      CashbackRuleIDIsRequired: "L'ID de la règle de cashback est obligatoire",
      LoyaltyProgramIDIsRequired: "L'ID du programme de fidélité est obligatoire",
      PointsAreRequired: 'Les points sont obligatoires',
      PointsMustBeANumber: 'Les points doivent être un nombre',
      PointsMustBeAnInteger: 'Les points doivent être un entier',
      CashbackIssuedSuccessfully: 'Cashback émis avec succès',
      IssueCashbackRequestSubmittedSuccessfully:
        "La demande d'émission de cashback a été soumise avec succès"
    },

    CustomerCampaigns: {
      ID: 'ID',
      HitThePinata: 'Frappez la pinata',
      ScratchCard: 'Carte à gratter',
      Plinko: 'Plinko',
      Name: 'Nom',
      CampaignType: 'Type de campagne',
      Status: 'Statut',
      StartDate: 'Date de début',
      EndDate: 'Date de fin',
      Actions: 'Actions',
      SearchCampaignsPlaceholder: 'Rechercher des campagnes',
      UnenrollCustomer: 'Désinscrire le client',
      NotStarted: 'Pas commencé',
      Active: 'Actif',
      Completed: 'Terminé',
      NotCompleted: 'Non terminé',
      Enrollable: 'Inscription possible',
      EndedAndNotEnrolled: 'Terminé et non inscrit',
      Enrolled: 'Inscrit',
      NotEnrolled: 'Non inscrit',
      SpinTheWheel: 'Tournez la roue',
      ShakeTheTree: "Secouez l'arbre",
      EnrollCustomer: 'Inscrire le client',
      SelectCampaignsPlaceholder: 'Sélectionner les campagnes',
      EnrollUserSuccessMessage: 'Campagne inscrite',
      UnenrollUserSuccessMessage: 'Campagne désinscrite',
      SomethingWentWrong: 'Une erreur est survenue',
      AddOrRemovePointsButton: 'Ajouter/Retirer des points',

      SelectedTypeCampaigns: {
        Customers: 'Clients',
        Campaigns: 'Campagnes',
        StampCampaign: 'Campagne de timbres',
        QuizCampaign: 'Campagne de quiz',
        SurveyCampaign: 'Campagne de sondages',
        GameCampaign: 'Campagne de jeux',
        ProgressCampaign: 'Campagne de progression',
        QuestCampaign: 'Campagne de quête',
        InstantRewardCampaign: 'Campagne de récompense instantanée',
        StreakCampaign: 'Campagne de série',
        CampaignProgress: 'Ce client est actuellement sur'
      },

      RaffleView: {
        TriggerName: 'Nom du déclencheur',
        RaffleRuleID: 'ID de la règle de tombola',
        TransactionDetails: 'Détails de la transaction',
        TransactionRuleID: 'ID de la règle de transaction',
        TriggeredDateOrTime: 'Date déclenchée',
        RaffleCode: 'Code de tombola',
        State: 'État',
        Reversed: 'Annulé',
        ReversalReason: "Motif de l'annulation",
        ReversedAt: 'Annulé le',
        ReversedBy: 'Annulé par',
        System: 'Système'
      },

      InstantRewardView: {
        TriggerName: 'Nom du déclencheur',
        RuleID: 'ID de la règle',
        TransactionDetails: 'Détails de la transaction',
        TriggeredDateOrTime: 'Date de complétion',
        Ref: 'Réf'
      },

      QuestView: {
        TriggerName: 'Nom du déclencheur',
        Task: 'Tâche',
        QuestRuleID: 'ID de la règle de quête',
        TransactionDetails: 'Détails de la transaction',
        TransactionRuleID: 'ID de la règle de transaction',
        TriggeredDateOrTime: 'Date / Heure déclenchée',
        State: 'État',
        Actions: 'Actions',
        MarkCompleted: 'Marquer comme terminé',
        MarkCompletedSuccessMessage: 'Points mis à jour avec succès!',
        MarkCompletedErrorMessage: 'Erreur de mise à jour des points'
      },

      CustomerProgressCard: {
        TriggerName: 'Nom du déclencheur',
        ProgressRuleID: 'ID de la règle de progression',
        TransactionDetails: 'Détails de la transaction',
        TransactionRuleID: 'ID de la règle de transaction',
        TriggeredDateOrTime: 'Date / Heure déclenchée',
        Points: 'Points',
        STAGE: 'ÉTAPE',
        ThisCustomerIsCurrentlyOn: 'Ce client est actuellement sur',
        FIRST: 'PREMIER',
        SECOND: 'DEUXIÈME',
        THIRD: 'TROISIÈME',
        FOURTH: 'QUATRIÈME',
        FIFTH: 'CINQUIÈME',
        SIXTH: 'SIXIÈME',
        SEVENTH: 'SEPTIÈME',
        EIGHTH: 'HUITIÈME',
        NINTH: 'NEUVIÈME',
        TENTH: 'DIXIÈME',
        ELEVENTH: 'ONZIÈME',
        TWELFTH: 'DOUZIÈME',
        THIRTEENTH: 'TREIZIÈME',
        FOURTEENTH: 'QUATORZIÈME',
        FIFTEENTH: 'QUINZIÈME',
        SIXTEENTH: 'SEIZIÈME',
        SEVENTEENTH: 'DIX-SEPTIÈME',
        EIGHTEENTH: 'DIX-HUITIÈME',
        NINETEENTH: 'DIX-NEUVIÈME',
        TWENTIETH: 'VINGTIÈME',
        TWENTYFIRST: 'VINGT ET UNIÈME',
        TWENTYSECOND: 'VINGT-DEUXIÈME',
        TWENTYTHIRD: 'VINGT-TROISIÈME',
        TWENTYFOURTH: 'VINGT-QUATRIÈME',
        TWENTYFIFTH: 'VINGT-CINQUIÈME',
        TWENTYSIXTH: 'VINGT-SIXIÈME',
        TWENTYSEVENTH: 'VINGT-SEPTIÈME',
        TWENTYEIGHTH: 'VINGT-HUITIÈME',
        TWENTYNINTH: 'VINGT-NEUVIÈME',
        THIRTITH: 'TRENTIÈME',
        THIRTYFIRST: 'TRENTE ET UNIÈME',
        THIRTYSECOND: 'TRENTE-DEUXIÈME',
        THIRTYTHIRD: 'TRENTE-TROISIÈME',
        THIRTYFOURTH: 'TRENTE-QUATRIÈME',
        THIRTYFIFTH: 'TRENTE-CINQUIÈME',
        THIRTYSIXTH: 'TRENTE-SIXIÈME',
        THIRTYSEVENTH: 'TRENTE-SEPTIÈME',
        THIRTYEIGHTH: 'TRENTE-HUITIÈME',
        THIRTYNINTH: 'TRENTE-NEUVIÈME',
        FORTIETH: 'QUARANTIÈME',
        FORTYFIRST: 'QUARANTE ET UNIÈME',
        FORTYSECOND: 'QUARANTE-DEUXIÈME',
        FORTYTHIRD: 'QUARANTE-TROISIÈME',
        FORTYFOURTH: 'QUARANTE-QUATRIÈME',
        FORTYFIFTH: 'QUARANTE-CINQUIÈME',
        FORTYSIXTH: 'QUARANTE-SIXIÈME',
        FORTYSEVENTH: 'QUARANTE-SEPTIÈME',
        FORTYEIGHTH: 'QUARANTE-HUITIÈME',
        FORTYNINTH: 'QUARANTE-NEUVIÈME',
        FIFTIETH: 'CINQUANTIÈME'
      },

      CustomerGameView: {
        TriesID: 'ID des essais',
        Status: 'Statut',
        AcquiredVia: 'Acquis via',
        ReasonCode: 'Code de raison',
        Email: 'Email',
        ID: 'ID',
        DateOfIssue: "Date d'émission",
        DateOfExpiry: "Date d'expiration",
        Outcomes: 'Résultats',
        VoucherID: 'ID du bon',
        NoOutcome: 'pas de résultat',
        SorrySomethingWentWrong: "Désolé, quelque chose s'est mal passé!",
        NoExpiry: 'Pas d’expiration',

        All: 'Tous',
        Issued: 'Émis',
        Redeem: 'Racheter',
        Expired: 'Expiré',
        Pending: 'En attente',
        CustomerSupport: 'Support client',
        PendingColumns: {
          RequestID: "Demande d'identité",
          Status: 'Statut',
          Reason: 'Raison',
          NumberOfTries: "Nombre d'essais",
          DateOfRequest: 'Date de demande',
          Actions: 'Actes'
        },
        ApproveIssue: 'Approuver le problème',
        ViewComments: 'Afficher les commentaires',
        ViewAndAddComments: 'Afficher et ajouter des commentaires',
        ApproveIssueSuccessMessage: 'La demande a été approuvée',
        ApproveIssueErrorMessage: "Quelque chose s'est mal passé",
        ApproveDenyModal: {
          Title: 'Approuver le problème des récompenses',
          OkText: 'Approuver',
          CancelText: 'Annuler',
          Description: "Êtes-vous sûr de vouloir approuver l'émission de cette récompense ? "
        },
        CustomerCardView: {
          Slot: 'Fente #',
          StampId: "Carte d'identité",
          Status: 'Statut',
          AcquiredVia: 'Acquis via',
          StampIssuedDate: "Date d'émission du timbre",
          StampRedeemedDate: "Date d'échange du timbre",
          Outcomes: 'Résultats',
          RedeemTheStamp: 'Échanger le timbre',
          EmptySlots: 'Emplacements vides',
          SlotEmpty: 'Emplacement vide',
          ID: 'IDENTIFIANT',
          VoucherID: 'Identifiant de bon',
          RewardID: 'Identifiant de récompense',
          NoRewards: 'Aucune récompense émise',
          NoRewardsIssued: 'Aucune récompense émise',
          Note: 'Note',
          Email: 'E-mail',
          SorrySomethingWentWrong: "Désolé, quelque chose s'est mal passé"
        }
      },

      CustomerQuizAndSurveyView: {
        QuestionNo: 'Question n°',
        Question: 'Question',
        Response: 'Réponse',
        SubmissionDateOrTime: 'Date / Heure de soumission',
        Result: 'Résultat'
      },

      IssueGameChangeModal: {
        MakerCheckerSuccessMessage: "Demande d'émission de chance de jeu soumise pour approbation",
        SuccessMessage: 'Chances de jeu émises avec succès!',
        ErrorMessage: "Erreur lors de l'émission des chances de jeu",
        IssueGameTriesButton: 'Émettre des essais de jeu',
        Title: 'Émettre une chance de jeu à',
        OkText: 'Émettre une chance',
        HowManyChances: 'Combien de chances?',

        IssueGameChanceButton: 'Problème de chance de jeu',
        ReasonForIssuance: "Raison de l'émission",
        ChanceCountValidationMessage: 'Veuillez spécifier un nombre de chances.',
        ReasonForIssuanceValidationMessage: "Veuillez spécifier une raison de l'émission."
      },

      CustomerStampCards: {
        CardHash: 'Carte #',
        StampCardID: 'ID de la carte de timbre',
        State: 'État',
        ExpiryDate: "Date d'expiration",
        DateOfParticipation: 'Date de participation',
        StampsCollected: 'Timbres collectés',
        CompletedDate: 'Date de fin',
        RewardsAchieved: 'Récompenses obtenues',

        PendingColumns: {
          RequestID: 'Numéro de demande',
          State: 'État',
          Reason: 'Raison',
          NumberOfStamps: 'Nombre de timbres',
          DateOfRequest: 'Date de demande',
          Actions: 'Actes'
        },
        CancelIssuance: "Annuler l'émission",
        ApproveIssue: 'Approuver le problème',
        ApproveIssueSuccessMessage: 'La demande a été approuvée',
        ApproveIssueErrorMessage: "Quelque chose s'est mal passé",
        ViewComments: 'Afficher les commentaires',
        Active: 'Actif',
        Completed: 'Terminé',
        Expired: 'Expiré',
        Pending: 'En attente',
        SorrySomethingWentWrong: "Désolé, quelque chose s'est mal passé"
      },

      IssueStampsModal: {
        MakerCheckerSuccessMessage: "Demande d'émission de timbres soumise pour approbation",
        SuccessMessage: 'Émission de timbres réussie!',
        IssueStampsButton: 'Émettre des timbres',
        Title: 'Émettre des timbres à',
        OkText: 'Émettre des timbres',
        HowManyStamps: 'Combien de timbres?',

        ErrorMessage: "Erreur lors de l'émission des timbres",
        CancelText: 'Annuler',
        ReasonForIssuance: "Raison de l'émission",
        CustomerFullNameDefault: 'Client actuel',
        StampsCountValidationMessage: 'Veuillez préciser le nombre de timbres.',
        ReasonToIssuanceValidationMessage: "Veuillez préciser le motif de l'émission"
      },

      DeleteRequestModal: {
        SuccessMessage: 'La demande a été annulée',
        ErrorMessage: "Quelque chose s'est mal passé",
        Title: "Annuler {{type}} Demande d'émission?",
        OkText: 'Confirmer',
        CancelText: 'Annuler',
        DescriptionLineOne: "Ce {{lowerCaseType}} est en attente d'approbation. ",
        DescriptionLineTwo:
          "Une fois l'annulation approuvée, cela {{lowerCaseType}} ne sera pas disponible et vous devrez le créer à nouveau."
      },

      IssueRewardModal: {
        RewardIssuedSuccessfully: 'Récompense émise avec succès!',
        ErrorIssueReward: "Erreur lors de l'émission de la récompense",
        IssueRewardTitle: 'Émettre des récompenses',
        IssueRewardOkText: 'Émettre une récompense',
        IssueRewardButton: 'Émettre une récompense',
        ReasonForAdjustment: "Raison de l'ajustement",
        PleaseSpecifyAReasonForAdjustment: 'Veuillez Spécifier Une Raison Pour L’Ajustement'
      },

      ProgressPointsPendingView: {
        RequestID: 'ID de demande',
        Status: 'Statut',
        Reason: 'Raison',
        NumberOfPoints: 'Nombre de points',
        DateOfRequest: 'Date de la demande',
        Actions: 'Actions',
        ApproveRequest: 'Approuver la demande',
        CancelIssuance: "Annuler l'émission",
        ViewComments: 'Voir les commentaires',
        ViewAndAddComments: 'Voir et ajouter des commentaires',
        ApproveRequestSuccessMessage: 'La demande a été approuvée',
        ApproveRequestErrorMessage: "Une erreur s'est produite",
        Pending: 'En attente',
        Completed: 'Terminé',
        All: 'Tout',
        ApproveDenyModal: {
          Title: "Approuver l'émission de points de progression",
          OkText: 'Approuver',
          CancelText: 'Annuler',
          Description:
            'Êtes-vous sûr de vouloir approuver cette émission de points de progression ? Cette action ne peut pas être annulée.'
        }
      },

      QuestTaskPendingView: {
        RequestID: 'ID de demande',
        Status: 'Statut',
        Task: 'Tâche',
        Reason: 'Raison',
        DateOfRequest: 'Date de la demande',
        Actions: 'Actions',
        ApproveRequest: 'Approuver la demande',
        CancelIssuance: "Annuler l'émission",
        ViewComments: 'Voir les commentaires',
        ViewAndAddComments: 'Voir et ajouter des commentaires',
        ApproveRequestSuccessMessage: 'La demande a été approuvée',
        ApproveRequestErrorMessage: "Une erreur s'est produite",
        Pending: 'En attente',
        Completed: 'Terminé',
        All: 'Tout',
        ReasonForCompletion: "Raison de l'achèvement",
        ReasonRequired: 'Veuillez spécifier une raison',
        ReasonModalTitle: 'Marquer la tâche de quête comme terminée',
        ReasonModalOkText: 'Soumettre',
        RequestSubmittedForApproval: 'Demande soumise pour approbation',
        ApproveDenyModal: {
          Title: "Approuver l'achèvement de la tâche de quête",
          OkText: 'Approuver',
          CancelText: 'Annuler',
          Description:
            'Êtes-vous sûr de vouloir approuver cet achèvement de tâche de quête ? Cette action ne peut pas être annulée.'
        }
      },

      InstantRewardPendingView: {
        RequestID: 'ID de demande',
        Status: 'État',
        Reason: 'Raison',
        DateOfRequest: 'Date de la demande',
        Actions: 'Actions',
        ApproveRequest: 'Approuver la demande',
        CancelIssuance: "Annuler l'émission",
        ViewComments: 'Voir les commentaires',
        ViewAndAddComments: 'Voir et ajouter des commentaires',
        ApproveRequestSuccessMessage: 'La demande a été approuvée',
        ApproveRequestErrorMessage: "Une erreur s'est produite",
        Pending: 'En attente',
        Completed: 'Terminé',
        All: 'Tout',
        RequestSubmittedForApproval: 'Demande soumise pour approbation',
        ApproveDenyModal: {
          Title: "Approuver l'émission de récompense instantanée",
          OkText: 'Approuver',
          CancelText: 'Annuler',
          Description:
            'Êtes-vous sûr de vouloir approuver cette émission de récompense instantanée ? Cette action ne peut pas être annulée.'
        }
      },

      RaffleTicketPendingView: {
        RequestID: 'ID de demande',
        Status: 'Statut',
        Reason: 'Raison',
        DateOfRequest: 'Date de la demande',
        Actions: 'Actions',
        ApproveRequest: 'Approuver la demande',
        CancelIssuance: "Annuler l'émission",
        ViewComments: 'Voir les commentaires',
        ViewAndAddComments: 'Voir et ajouter des commentaires',
        ApproveRequestSuccessMessage: 'La demande a été approuvée',
        ApproveRequestErrorMessage: "Une erreur s'est produite",
        Pending: 'En attente',
        Issued: 'Émis',
        All: 'Tout',
        RequestSubmittedForApproval: 'Demande soumise pour approbation',
        ApproveDenyModal: {
          Title: "Approuver l'émission de billet de tombola",
          OkText: 'Approuver',
          CancelText: 'Annuler',
          Description:
            'Êtes-vous sûr de vouloir approuver cette émission de billet de tombola ? Cette action ne peut pas être annulée.'
        }
      },

      AddRemovePointsModal: {
        RequestSubmittedForApproval: 'Demande soumise pour approbation',
        PointsUpdatedSuccessfully: 'Points mis à jour avec succès!',
        ErrorUpdatingPoints: 'Erreur lors de la mise à jour des points',
        AddOrRemovePointsButton: 'Ajouter/Retirer des points',
        AdjustProgressCampaignPoints: 'Ajuster les points de la campagne de progression',
        OkText: 'Ajuster les points',
        HowManyPointsToAddOrRemove: 'Combien de points ajouter/retirer?',
        ReasonForAdjustment: "Raison de l'ajustement"
      }
    },

    CustomerStamps: {
      All: 'Tous',
      Active: 'Actif',
      Inactive: 'Inactif',
      Name: 'Nom',
      Status: 'Statut',
      Started: 'Commencé',
      Ended: 'Terminé',
      ID: 'IDENTIFIANT',
      SearchPlaceholder: 'Rechercher une campagne par son nom',
      EnrollCampaignModal: {
        SuccessMessage: 'Campagne inscrite réussie!',
        ErrorMessage: 'La campagne inscrite a échoué.',
        CampaignIDValidationMessage: 'Veuillez spécifier une campagne',
        FullNameDefault: 'Client actuel',
        ManualEnrollButton: 'Inscription manuelle',
        Title: 'Inscrire',
        OkText: 'Inscrire le client',
        CancelText: 'Annuler'
      },
      CampaignSelectField: {
        Label: 'Sélectionner la campagne',
        Edit: 'Modifier',
        Add: 'Ajouter',
        Campaign: 'Campagne'
      },

      CampaignSelectModal: {
        Title: 'Sélectionnez une campagne',
        CancelText: 'Annuler',
        OkText: 'Ajouter une campagne',
        SearchPlaceholder: 'Trouvez une campagne par nom, type ou marchand',
        Name: 'Nom',
        ID: 'IDENTIFIANT',
        Status: 'Statut',
        Tags: 'Balises',
        StartDate: 'Date de début',
        EndDate: 'Date de fin'
      }
    },

    CustomerGames: {
      Name: 'Nom',
      ID: 'IDENTIFIANT',
      Status: 'Statut',
      GameType: 'Type de jeu',
      TriesRedeemed: 'Essais échangés',
      Started: 'Commencé',
      Ended: 'Terminé',
      SearchPlaceholder: 'Trouvez une campagne par son nom',
      SorrySomethingWentWrong: "Désolé, quelque chose s'est mal passé",
      Tabs: {
        All: 'Tous',
        Active: 'Actif',
        Approved: 'Approuvé',
        Inactive: 'Inactif',
        Ended: 'Terminé'
      }
    }
  }
};
